import React, { useEffect } from 'react';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import SelectField from '../../../../common/formComponents/SelectField/SelectField';
import { fieldNames, HOUR_INTERVAL_ID } from '../constants';
import useHouseAcceptanceIntervals from '../../../../../queries/useHouseAcceptanceIntervals';

const IntervalIdRow = ({ form }) => {
  const { data: intervals, isFetching } = useHouseAcceptanceIntervals();

  const validateToTimeFields = (_rule, value, callback) => {
    if (value) {
      const startTime = form.getFieldValue(fieldNames.startTime);
      const endTime = form.getFieldValue(fieldNames.endTime);
      const lunchStartTime = form.getFieldValue(fieldNames.lunchStartTime);
      const lunchEndTime = form.getFieldValue(fieldNames.lunchEndTime);

      if (startTime) {
        form.validateFields([fieldNames.startTime], { force: true });
      }

      if (endTime) {
        form.validateFields([fieldNames.endTime], { force: true });
      }

      if (lunchStartTime) {
        form.validateFields([fieldNames.lunchStartTime], { force: true });
      }

      if (lunchEndTime) {
        form.validateFields([fieldNames.lunchEndTime], { force: true });
      }
    }

    callback();
  };

  useEffect(() => {
    if (Boolean(intervals?.length)) {
      form.setFieldsValue({ [fieldNames.intervalId]: HOUR_INTERVAL_ID });
    }
  }, [intervals]);

  return (
    <FormRow>
      <SelectField
        label="Продолжительность приемки"
        name={fieldNames.intervalId}
        valueKey="id"
        contentKey="name"
        selectProps={{
          disabled: isFetching,
        }}
        selectOptions={intervals || []}
        form={form}
        options={{
          initialValue: undefined,
          rules: [
            {
              type: 'number',
              required: true,
              message: 'Укажите продолжительность приемки',
            },
            {
              validator: validateToTimeFields,
            },
          ],
        }}
      />
    </FormRow>
  );
};

export default IntervalIdRow;
